import React, { FC } from 'react';
import { Field, FieldProps } from 'formik';
import { ProcedureAssignmentDropdown } from '../ProcedureAssignmentDropdown/ProcedureAssignmentDropdown';
import { FormSchemaItem } from '@shared/components/forms/FormSchema';
import { OptionType } from '@shared/components/SelectDropdown';

export type FormikProcedureAssignmentProps = {
    schema: FormSchemaItem,
    className?: string,
    options: Array<object>,
    components?: object,
    closeMenuOnSelect?: boolean,
    hideSelectedOptions?: boolean,
    isMulti?: boolean,
    isClearable?: boolean;
    isSearchable?: boolean;
    onChange?: (value: OptionType, fieldName: string,) => void,
    value?: string,
    disabled?: boolean,
}

export const FormikProcedureAssignment: FC<FormikProcedureAssignmentProps> = props => {
    const { schema, ...dropdownProps } = props;

    return (
        <Field name={schema.fieldName}>
            {({ field, form, meta }: FieldProps) => (
                <ProcedureAssignmentDropdown
                    field={field}
                    form={form}
                    meta={meta}
                    error={meta.error}
                    {...schema}
                    {...dropdownProps}
                    fieldName={field.name}
                />
            )}
        </Field>
    )
}
